import Vue from 'vue'
import VueRouter from 'vue-router'

// Router
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'new-activity',
    component: () => import(/* webpackChunkName: "newActivity" */ '../views/NewActivity.vue')
  },
  {
    path: '/new-activity-deleted',
    name: 'new-activity-deleted',
    component: () => import(/* webpackChunkName: "newActivityDeleted" */ '../views/NewActivityDeleted.vue')
  },
  {
    path: '/tracked-route/:id',
    name: 'tracked-route',
    // route level code-splitting
    // this generates a separate chunk (trackedRoutes.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "trackedRoutes" */ '../views/TrackedRoute.vue')
  },
  {
    path: '/map-host/:id',
    name: 'map-host',
    // route level code-splitting
    // this generates a separate chunk (trackedRoutes.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "trackedRoutes" */ '../views/MapHost.vue')
  },
  {
    path: '/404',
    alias: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('Router: beforeEach - to = ' + to)
  // console.log('Router: beforeEach - from = ' + from)
  // console.log('next =', next)
  next()
})

export default router
